var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "feed-message",
      class: {
        "my-message": _vm.message.is_mine,
        sending: _vm.message.message_id == null,
        error: _vm.message.sending_error != null
      }
    },
    [
      _c(
        "div",
        {
          staticClass: "avatar",
          style: { backgroundColor: _vm.message.user_background_color }
        },
        [_vm._v(" " + _vm._s(_vm.message.user_initials) + " ")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "content-wrapper mx-2 position-relative" }, [
        _c("div", { staticClass: "px-3 pt-2" }, [
          _c("b", [_vm._v(_vm._s(_vm.message.user_name))]),
          _vm._v("   \n      "),
          _c("span", { staticStyle: { color: "#777" } }, [
            _vm._v(
              _vm._s(_vm.shortTimestamp(_vm.message.message_creation_datetime))
            )
          ])
        ]),
        _vm._v(" "),
        _vm.message.message_type == "1"
          ? _c("div", { staticClass: "px-3 pb-2 pt-1" }, [
              _c("div", {
                domProps: {
                  innerHTML: _vm._s(
                    _vm.advancedFormat(_vm.message.message_content)
                  )
                }
              }),
              _vm._v(" "),
              _vm.message.files != null && _vm.message.files.length > 0
                ? _c(
                    "div",
                    _vm._l(_vm.message.files, function(file, index2) {
                      return _c("div", { key: index2 }, [
                        _vm.isFileImage(file)
                          ? _c(
                              "div",
                              [
                                _c(
                                  "fancy-box",
                                  {
                                    staticStyle: {
                                      width: "100%",
                                      height: "100%"
                                    },
                                    attrs: {
                                      href: _vm.fileAttachmentImage(file)
                                    }
                                  },
                                  [
                                    _c("img", {
                                      staticStyle: {
                                        width: "100%",
                                        height: "100%",
                                        "object-fit": "contain"
                                      },
                                      attrs: {
                                        src: _vm.fileAttachmentThumbnail(file),
                                        alt: ""
                                      }
                                    })
                                  ]
                                )
                              ],
                              1
                            )
                          : _c("div", { staticClass: "feed-file" }, [
                              _c(
                                "div",
                                { staticClass: "feed-file-thumbnail" },
                                [
                                  _vm.isFilePdf(file) || _vm.isFileText(file)
                                    ? _c(
                                        "a",
                                        {
                                          staticStyle: {
                                            width: "100%",
                                            height: "100%",
                                            display: "block"
                                          },
                                          attrs: {
                                            href: _vm.filePreviewLink(file),
                                            target: "_blank"
                                          }
                                        },
                                        [
                                          _c("img", {
                                            staticStyle: {
                                              width: "100%",
                                              height: "100%",
                                              "object-fit": "contain"
                                            },
                                            attrs: {
                                              src: _vm.fileAttachmentThumbnail(
                                                file
                                              ),
                                              alt: ""
                                            }
                                          })
                                        ]
                                      )
                                    : _c(
                                        "a",
                                        {
                                          staticStyle: {
                                            width: "100%",
                                            height: "100%",
                                            display: "block"
                                          },
                                          attrs: { href: "javascript:;" },
                                          on: {
                                            click: function($event) {
                                              return _vm.downloadFile(file)
                                            }
                                          }
                                        },
                                        [
                                          _c("img", {
                                            staticStyle: {
                                              width: "100%",
                                              height: "100%",
                                              "object-fit": "contain"
                                            },
                                            attrs: {
                                              src: _vm.fileAttachmentThumbnail(
                                                file
                                              ),
                                              alt: ""
                                            }
                                          })
                                        ]
                                      )
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "flex-grow-1 h-100" }, [
                                _c("div", { staticClass: "bold" }, [
                                  _vm._v(_vm._s(file.file_title))
                                ]),
                                _vm._v(" "),
                                _c("div", [
                                  _c("span", [
                                    file.file_id != null
                                      ? _c(
                                          "a",
                                          {
                                            attrs: { href: "javascript:;" },
                                            on: {
                                              click: function($event) {
                                                return _vm.downloadFile(file)
                                              }
                                            }
                                          },
                                          [_vm._v("Télécharger")]
                                        )
                                      : _c("span", [
                                          _vm._v("Téléchargement...")
                                        ])
                                  ])
                                ])
                              ])
                            ])
                      ])
                    }),
                    0
                  )
                : _vm._e()
            ])
          : _vm.message.message_type == "2"
          ? _c("div", { staticClass: "px-3 pb-2 pt-1" }, [
              _c("i", { staticClass: "icon-login font-green-jungle" }),
              _vm._v(" L'utilisateur a joint cette conversation.")
            ])
          : _vm.message.message_type == "3"
          ? _c("div", { staticClass: "px-3 pb-2 pt-1" }, [
              _c("i", { staticClass: "icon-logout font-red" }),
              _vm._v(" L'utilisateur a quitté cette conversation.")
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "position-absolute my-message-actions",
            staticStyle: { top: "-5px", right: "5px" }
          },
          [
            _c(
              "button",
              {
                staticClass: "btn btn-sm red",
                staticStyle: { padding: "1px 5px", "border-radius": "15px" },
                on: {
                  click: function($event) {
                    return _vm.deleteMessageAsk($event, _vm.message)
                  }
                }
              },
              [_c("i", { staticClass: "fa fa-trash" })]
            )
          ]
        )
      ]),
      _vm._v(" "),
      _vm.message.message_id == null
        ? _c("div", [
            _vm.message.sending_error === undefined
              ? _c("img", {
                  staticStyle: { height: "20px" },
                  attrs: { src: _vm.spinnerSVG }
                })
              : _c("span", { staticClass: "font-red text-right" }, [
                  _vm._v("\n      " + _vm._s(_vm.message.sending_error)),
                  _c("br"),
                  _vm._v(" "),
                  _vm.message.files === undefined
                    ? _c(
                        "a",
                        {
                          staticClass: "text-right",
                          attrs: { href: "javascript:;" },
                          on: {
                            click: function($event) {
                              return _vm.resendMessage($event, _vm.message)
                            }
                          }
                        },
                        [_vm._v("Renvoyer")]
                      )
                    : _vm._e()
                ])
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }